<div mat-dialog-content>
    <h2 class="verify-title mt-0">Regenerate Recovery Codes</h2>

    <p>For security reason, enter your password to confirm your identity.</p>

    <div class="notification warning-msg" fxLayout="row" fxLayoutAlign="start center">
        <p>
            <mat-icon>warning</mat-icon>
            <span>Old codes won't work after generating new ones.</span>
        </p>
    </div>

    <form [formGroup]="formGroup">
        <mat-form-field class="mfa-code mb-8 mt-8">
            <mat-label>Password</mat-label>
            <input matInput
                   formControlName="passwordCtrl"
                   placeholder="Enter password"
                   [type]="hidePassword ? 'password' : 'text'"
                   [required]="true"
                   ngcAutofocus
            >
            <mat-icon matSuffix
                      class="hide-password-icon"
                      (click)="hidePassword = !hidePassword"
            >
                {{hidePassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
        </mat-form-field>
    </form>
</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button
            type="button"
            (click)="onCancel()"
            class="mr-8"
            tabindex="12"
    >
        Cancel
    </button>

    <button mat-raised-button
            color="primary"
            (click)="onVerifyPassword()"
            [disabled]="formGroup?.invalid || isSpinnerActive"
    >
        Regenerate
    </button>
</mat-dialog-actions>
